
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GuardianService } from '../../_services/guardian.service';

@Component({
  selector: 'app-guardian-home-show',
  templateUrl: './guardian-home-show.component.html',
  styleUrls: ['./guardian-home-show.component.css']
})

export class GuardianHomeShowComponent implements OnInit {
  guardian:any = undefined
  firstQuizYes=undefined
  server_user_id=0
  constructor(
    private guardianService: GuardianService,
    private route: ActivatedRoute) {

  }
  ngOnInit(): void {

    this.route.params.subscribe(
      params => {
        this.server_user_id=+params['server_user_id']
        if (this.server_user_id) {
          this.guardianService.getByUserId(this.server_user_id).subscribe(
          guardianData => {
            this.guardian = guardianData
            this.firstQuizYes=this.guardian['first_quiz_yes']
          })
        }
      });


  }
  reloadMainHomePage(regInfo:String){
    this.guardian=undefined

    this.guardianService.getByUserId(this.server_user_id).subscribe(

      guardianData => {
        this.guardian = guardianData
        this.firstQuizYes=this.guardian['first_quiz_yes']
      })
  }
}
